import React from "react";
import { useTranslation } from "../../../../i18n/LanguageContext";

function UserDetails({ userDetails, loading, onInputChange, onSubmit }) {
  const { t } = useTranslation();
  return (
    <div className="common-form-group">
      <form onSubmit={onSubmit}>
        {/* First row: City, State, Country */}
        <div className="common-form-row three-column indented-below-h4">
          <div className="common-form-field">
            <label>{t("usermgmt.details.city")}</label>
            <input
              type="text"
              name="city"
              value={userDetails.city}
              onChange={onInputChange}
              placeholder={t("usermgmt.details.cityPlaceholder")}
            />
          </div>
          <div className="common-form-field">
            <label>{t("usermgmt.details.state")}</label>
            <input
              type="text"
              name="state"
              value={userDetails.state}
              onChange={onInputChange}
              placeholder={t("usermgmt.details.statePlaceholder")}
            />
          </div>
          <div className="common-form-field">
            <label>{t("usermgmt.details.country")}</label>
            <input
              type="text"
              name="country"
              value={userDetails.country}
              onChange={onInputChange}
              placeholder={t("usermgmt.details.countryPlaceholder")}
            />
          </div>
        </div>

        {/* Second row: Age, Profession, Hobby */}
        <div className="common-form-row three-column indented-below-h4">
          <div className="common-form-field">
            <label>{t("usermgmt.details.ageRange")}</label>
            <select
              name="ageRange"
              value={userDetails.ageRange}
              onChange={onInputChange}
            >
              <option value="">
                {t("usermgmt.details.ageRangePlaceholder")}
              </option>
              <option value="21-30">21-30</option>
              <option value="31-40">31-40</option>
              <option value="41-50">41-50</option>
              <option value="51-60">51-60</option>
              <option value="61-70">61-70</option>
              <option value="71+">71+</option>
            </select>
          </div>
          <div className="common-form-field">
            <label>{t("usermgmt.details.profession")}</label>
            <input
              type="text"
              name="profession"
              value={userDetails.profession}
              onChange={onInputChange}
              placeholder={t("usermgmt.details.professionPlaceholder")}
            />
          </div>
          <div className="common-form-field">
            <label>{t("usermgmt.details.hobbies")}</label>
            <input
              type="text"
              name="hobby"
              value={userDetails.hobby}
              onChange={onInputChange}
              placeholder={t("usermgmt.details.hobbiesPlaceholder")}
            />
          </div>
        </div>

        {/* Third row: Additional Info (spans full width) */}
        <div className="common-form-row full-width indented-below-h4">
          <div className="common-form-field">
            <label>{t("usermgmt.details.additionalInfo")}</label>
            <textarea
              name="additionalInfo"
              value={userDetails.additionalInfo || ""}
              onChange={onInputChange}
              placeholder={t("usermgmt.details.additionalInfoPlaceholder")}
              rows="2"
            />
          </div>
        </div>
        <div className="common-button-group indented-below-h4">
          <button
            type="submit"
            className="common-button primary"
            disabled={loading}
          >
            {loading
              ? t("usermgmt.details.saving")
              : t("usermgmt.details.saveDetails")}
          </button>
        </div>
      </form>
    </div>
  );
}

export default UserDetails;
